var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.44482V11.4448H6V13.4448H11V18.4448H13V13.4448H18V11.4448H13V6.44482H11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24.4448C18.6274 24.4448 24 19.0722 24 12.4448C24 5.81741 18.6274 0.444824 12 0.444824C5.37258 0.444824 0 5.81741 0 12.4448C0 19.0722 5.37258 24.4448 12 24.4448ZM12 22.4448C17.5228 22.4448 22 17.9677 22 12.4448C22 6.92198 17.5228 2.44482 12 2.44482C6.47715 2.44482 2 6.92198 2 12.4448C2 17.9677 6.47715 22.4448 12 22.4448Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.df4d157460582236e85259578a6e1ecb.svg";
export { ForwardRef as ReactComponent };